export enum IconType {
  CheckCircle = 'CheckCircle',
  CloudDownload = 'CloudDownload',
  FileUpload = 'FileUpload',
  Forward = 'Forward',
  Info = 'Info',
  Notifications = 'Notifications',
  Plus = 'Plus',
  AddCircle = 'AddCircle',
  ArticleRoundedIcon = 'ArticleRoundedIcon',
  Email = 'MailOutlineRounded',
  Delete = 'DeleteRoundedIcon',
  Share = 'ShareRoundedIcon',
  BrainpoolDelete = 'BrainpoolDelete',
}

export enum IconPosition {
  Before = 'before',
  After = 'after',
}
